if (!customElements.get('cider-style-products')) {
  customElements.define(
    'cider-style-products',
    class CiderStyleProducts extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-cider-product]').forEach((slot) => this.loadProduct(slot));
      }

      async loadProduct(slot) {
        try {
          const response = await fetch(slot.dataset.productUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const productItem = Array.from(page.querySelectorAll('li.js-pagination-result')).find((item) =>
            item.querySelector('.card--product')
          );

          if (!productItem) {
            slot.innerHTML = '<p class="cider-module__product-status">No matching product is currently available.</p>';
            return;
          }

          slot.innerHTML = productItem.innerHTML;

          if (typeof initLazyImages === 'function') {
            initLazyImages();
          }
        } catch (error) {
          slot.innerHTML = '<p class="cider-module__product-status">Product information is temporarily unavailable.</p>';
        }
      }
    }
  );
}
